import { useNextT } from "../i18n";
import { useCanSeeNotifications } from "./useCanSeeNotifications";
import { useOpenInbox } from "../approvals/openInbox";
import { useBellCount } from "../approvals/bell";
import { Icon } from "./icons";
import { HelpMenu } from "./HelpMenu";
import { AccountMenu } from "./AccountMenu";
import s from "./SideFooter.module.scss";

/** The bottom of the menu column / phone drawer: a divider, Help, Notifications (with its count), then the account card.
 *  In the drawer (onChoose given) the bell lives in the slim top bar instead, so it is not repeated here. */
export const SideFooter = ({ onChoose }: { onChoose?(go: () => void): void }) => {
  const { t } = useNextT();
  // The new notifications panel (2D F9), never today's; its number from the new counts only.
  const openInbox = useOpenInbox();
  const canSeeNotifications = useCanSeeNotifications() && !!openInbox;
  const count = useBellCount(canSeeNotifications && !onChoose);
  return (
    <div className={s.footer}>
      <div className={s.cluster}>
        <HelpMenu onChoose={onChoose} />
        {canSeeNotifications && !onChoose && (
          <button type="button" className={s.item} aria-label={t("shell.top.notifications_count", { count })} onClick={() => openInbox?.()}>
            <Icon name="bell" /><span>{t("shell.top.notifications")}</span>
            {count > 0 && <span className={s.badge} aria-hidden="true">{count > 99 ? "99+" : count}</span>}
          </button>
        )}
      </div>
      <div className={s.account}><AccountMenu onChoose={onChoose} /></div>
    </div>
  );
};
